import { mapCommonFile } from './CommonFile.mappers';
export const mapSwf = (file, baseFile) => ({
  ...mapCommonFile(file, baseFile),
  mediaType: 'swf',
  width: null,
  height: null
});
//# sourceMappingURL=Swf.mappers.js.map